// Single source of truth for social-share meta (OG/Twitter) of standalone
// pages. Imported by the page components (runtime tags via usePageMeta) and by
// vite.config.ts (static tags baked into prerendered HTML for crawlers, which
// never execute JS). Keep copy free of double quotes — values are interpolated
// into HTML attributes by the build plugin.

export const siteOrigin = "https://prompt2bot.com";

export const landingSocialMeta = {
  path: "/",
  title: "AI agents for everyday work | prompt2bot",
  description:
    "Build AI agents in plain language for customer support, research, operations, and personal work. Connect your tools and start on the web. Free trial limits apply.",
  image: "/logo.png",
};

export const pricingSocialMeta = {
  path: "/pricing",
  title: "AI agent pricing and free trial terms | prompt2bot",
  description:
    "Compare prompt2bot plans, monthly USD prices, and LLM run allowances. See the 7-day free trial terms before choosing a plan.",
  image: "/logo.png",
};

export const agencySocialMeta = {
  path: "/agency",
  title: "The Agency — 250+ AI specialists, one click away | prompt2bot",
  description:
    "Hire a whole AI agency: engineers, designers, marketers and strategists. Pick a role and instantly get a personal AI agent with that exact skill, on WhatsApp, Telegram or web.",
  image: "/og/agency.png",
};

export const talkToSkillSocialMeta = {
  path: "/talk-to-skill",
  title: "Talk to a Skill — chat with any AI skill instantly | prompt2bot",
  description:
    "Paste any skill link (GitHub repo, Tank package, npm module) and instantly get a dedicated AI agent equipped with that capability, on WhatsApp, Telegram or web.",
  image: "/og/talk-to-skill.png",
};

export const extractSkillNameFromSourceUrl = (
  sourceUrl?: string | null,
): string => {
  if (!sourceUrl) return "";
  try {
    const decoded = decodeURIComponent(sourceUrl).trim();
    if (decoded.startsWith("tank:")) {
      const bare = decoded.slice(5).replace(/^@[^/]+\//, "");
      const atIndex = bare.lastIndexOf("@");
      const name = atIndex > 0 ? bare.slice(0, atIndex) : bare;
      return name.replace(/^p2b-/, "");
    }
    if (decoded.startsWith("@")) {
      const bare = decoded.replace(/^@[^/]+\//, "");
      const atIndex = bare.lastIndexOf("@");
      const name = atIndex > 0 ? bare.slice(0, atIndex) : bare;
      return name.replace(/^p2b-/, "");
    }
    if (decoded.startsWith("http://") || decoded.startsWith("https://")) {
      const parsed = new URL(decoded);
      const segments = parsed.pathname.split("/").filter(Boolean);
      const last = segments[segments.length - 1];
      return last ? last.replace(/\.git$/, "").replace(/^p2b-/, "") : "";
    }
    return decoded.replace(/^p2b-/, "");
  } catch {
    return "";
  }
};

export const talkToSkillMetaForName = (skillName?: string | null) => {
  if (!skillName) return talkToSkillSocialMeta;
  return {
    path: "/talk-to-skill",
    title: `Talk to ${skillName} — AI Agent | prompt2bot`,
    description:
      `Chat with the ${skillName} AI agent on WhatsApp, Telegram, or web.`,
    image: talkToSkillSocialMeta.image,
  };
};

export const mentatSocialMeta = {
  path: "/mentat",
  title: "Mentat — The personal assistant with its own computer | prompt2bot",
  description:
    "An external brain with its own phone line, WhatsApp, and computer. Manages your calendar, answers phone calls, and builds live web dashboards and automations.",
  image: "/og/talk-to-skill.png",
};

export const automationSocialMeta = {
  path: "/automation",
  title: "AI Workflow Automation without the Spaghetti Nodes | prompt2bot",
  description:
    "Clean, maintainable automations without vendor lock-in. Just describe what you want in plain words to connect your apps, emails, and spreadsheets.",
  image: "/og/talk-to-skill.png",
};

export const businessSocialMeta = {
  path: "/business",
  title: "Automate Your Business with Custom AI Agents | prompt2bot",
  description:
    "Build custom AI employees for customer support, lead qualification, and operations on WhatsApp and web in minutes without writing code.",
  image: "/og/talk-to-skill.png",
};

export const agenticUiSocialMeta = {
  path: "/agentic-ui",
  title: "Agentic UI: Turn your API into an intelligent agent | prompt2bot",
  description:
    "Give your coding agent our prompt2bot.com/llms.txt and a token to connect your existing API to an agent layer on Web, WhatsApp, and Telegram.",
  image: "/og/talk-to-skill.png",
};

export const autoLandingSocialMeta = {
  path: "/auto-landing",
  title: "Auto Landing: describe a page and watch it get built | prompt2bot",
  description:
    "Describe the landing page you want and an agent builds it live, then keeps changing it as you talk to it.",
  image: "/og/talk-to-skill.png",
};

export const pageSocialMeta = [
  landingSocialMeta,
  pricingSocialMeta,
  agencySocialMeta,
  talkToSkillSocialMeta,
  mentatSocialMeta,
  automationSocialMeta,
  businessSocialMeta,
  agenticUiSocialMeta,
  autoLandingSocialMeta,
];
